import fetch from '@/service/fetch'
import type {
  AccountLoginApi,
  SmsOrEmailLoginApi,
  TypeResponseGetVerifyCode,
  // GetDeveloperInfo,
  GetDeveloperInfoApi,
  TypeResponseLogout,
  ReqCheckLogin,
  ResetPasswordApi,
  AccountRegisterApi,
  AccountAppealCodeApi,
  AccountAppealApi
} from '../types'

/**
 * 账号密码登录
 */
const reqAccountLogin: AccountLoginApi = (data = {}) => {
  return fetch({ method: 'post', url: '/login/loginByPwd', data })
}

/**
 * 短信或邮箱验证码登录
 * @description 国内版：手机号获取验证码
 * @description 国际版：邮箱获取验证码
 */
const reqSmsOrEmailLogin: SmsOrEmailLoginApi = (data = {}) => {
  return fetch({ method: 'post', url: '/login/loginByCode', data })
}

/**
 * 获取验证码
 */
const reqGetVerifyCode: TypeResponseGetVerifyCode = (data = {}) => {
  return fetch({ method: 'post', url: '/login/getLoginCode', data })
}

/**
 * 重置密码
 */
const reqResetPassword: ResetPasswordApi = (data = {}) => {
  return fetch({ method: 'post', url: '/login/retrieve', data })
}

/**
 * 注册（国际+国内）
 */
const reqAccountRegister: AccountRegisterApi = (data = {}) => {
  return fetch({ method: 'post', url: '/login/register', data })
}

// 退出登录
const requestLogout: TypeResponseLogout = (data = {}) => {
  return fetch({ method: 'post', url: '/logout/index', data })
}

/**
 * 获取开发者信息
 */
const reqGetDeveloperInfo: GetDeveloperInfoApi = (data = {}) => {
  return fetch({ method: 'post', url: '/account/getDeveloperInfo', data })
}

/** 判断是否登录 */
const reqCheckLogin: ReqCheckLogin = (data = {}) => {
  return fetch({ method: 'post', url: '/login/isLogin', data })
}

/**
 * 账号申诉获取验证码
 */
const reqAccountAppealCode: AccountAppealCodeApi = (data = {}) => {
  return fetch({ method: 'post', url: '/appeal/getCode', data })
}

/**
 * 账号申诉
 */
const reqAccountAppeal: AccountAppealApi = (data = {}) => {
  return fetch({ method: 'post', url: '/appeal/apply', data })
}

export {
  reqAccountLogin,
  reqSmsOrEmailLogin,
  reqGetVerifyCode,
  reqResetPassword,
  reqAccountRegister,
  requestLogout,
  reqGetDeveloperInfo,
  reqCheckLogin,
  reqAccountAppeal,
  reqAccountAppealCode
}
